<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1102_1921)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <path
    d="M50.5 32C50.5 42.2173 42.2173 50.5 32 50.5C21.7827 50.5 13.5 42.2173 13.5 32C13.5 21.7827 21.7827 13.5 32 13.5C42.2173 13.5 50.5 21.7827 50.5 32Z"
    fill="url(#paint1_linear_1102_1921)"
    stroke="url(#paint2_linear_1102_1921)"
  />
  <path
    d="M50.5 32C50.5 42.2173 42.2173 50.5 32 50.5C21.7827 50.5 13.5 42.2173 13.5 32C13.5 21.7827 21.7827 13.5 32 13.5C42.2173 13.5 50.5 21.7827 50.5 32Z"
    fill="url(#paint3_linear_1102_1921)"
    stroke="url(#paint4_linear_1102_1921)"
  />
  <path
    d="M32 24L32 40L43 32L32 24Z"
    fill="white"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M32 35H13V29H32V35Z"
    fill="url(#paint5_linear_1102_1921)"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1102_1921"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1102_1921"
      x1="32"
      y1="13"
      x2="-15.2756"
      y2="31.4327"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1102_1921"
      x1="44.5735"
      y1="10.0769"
      x2="24.9569"
      y2="28.236"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
    <linearGradient
      id="paint3_linear_1102_1921"
      x1="32"
      y1="13"
      x2="-15.2756"
      y2="31.4327"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint4_linear_1102_1921"
      x1="44.5735"
      y1="10.0769"
      x2="24.9569"
      y2="28.236"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
    <linearGradient
      id="paint5_linear_1102_1921"
      x1="28.9773"
      y1="32.75"
      x2="13"
      y2="32.75"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
